<template>
    <div class="qksm qksm10">
        <div class="nogap">
            <p><b>（五）绩效目标设置情况</b></p>
            <p class="hide_pdf red">
                （2021年相关财政拨款安排的项目是否全部涉密<reason type="select" classname="qksm select " name="预算资金涉密" v-model:value="qksm['预算资金涉密']" optionarr="请选择,是,否"></reason>）<br />
            </p>
            <p>
                <span v-if="qksm['预算资金涉密']=='是'">
                    2021年{{$store.state.divData.divname}}财政拨款安排的项目，按规定不涉及绩效目标设置公开事项。
                </span>
                <span v-else>
                    <span v-if="isPdf && num(qksm['涉及财政拨款'])==0">
                        2021年{{$store.state.divData.divname}}无财政拨款项目，不涉及绩效目标设置。
                    </span>
                    <span v-else>
                        2021年{{$store.state.divData.divname}}项目支出实现绩效目标管理全覆盖，涉及财政拨款
                        <reason type="money" classname="qksm money" name="涉及财政拨款" v-model:value="qksm['涉及财政拨款']"></reason>万元。
                    </span>
                </span>
                <span v-if="$store.state.divData.type != 0" class="hide_pdf red">
                    （部门整体绩效管理试点是否开展<reason type="select" classname="qksm select " name="整体绩效开展" v-model:value="qksm['整体绩效开展']" optionarr="请选择,是,否"></reason>）<br />
                </span>
                <span v-if="qksm['整体绩效开展']=='是' && $store.state.divData.type != 0">
                    编制了2021年部门整体绩效目标。
                </span>
                <span v-if="num(qksm['涉及财政拨款'])>0 && qksm['预算资金涉密']!='是'">
                    其中，本{{typeText}}所主管项目资金的绩效目标表如下：
                    <span class="hide_pdf upload" @click="uploadJx('bmzxzj')">*【->点此前往】上传项目资金的绩效目标表</span>
                    <span class="hide_pdf red">
                        （需分项列示，{{typeText}}100万元以上财政拨款安排的非涉密项目绩效目标信息表全部公开，如{{typeText}}无100万元以上项目，则至少选择一个项目的绩效目标进行公开。）
                    </span>
                </span>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm10",
        components: {
            reason,
        },
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
                typeText: this.$store.state.divData.type == 0 ? "单位" : "部门",
                attachments: this.$store.state.divData.attachments
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.attachments = this.$store.state.divData.attachments
            this.inspect()
        },
        watch: {
            $route() {
                this.attachments = this.$store.state.divData.attachments
                this.inspect()
            },
        },
        methods: {
            uploadJx(name) {
                this.$router.push({ path: '/div/uploadPerform', query: { divid: this.$route.query.divid, tag: name }, });
            },
            inspect() {
                if (this.qksm['预算资金涉密'] != '是' && this.num(this.qksm['涉及财政拨款']) > 0 && this.attachments.filter(e => e.claims.tag == 'bmzxzj').length == 0) {
                    this.addOrSet("jx1", "请上传项目资金的绩效目标表。");
                } else if ((this.qksm['预算资金涉密'] == '是' || this.num(this.qksm['涉及财政拨款']) == 0) && this.attachments.filter(e => e.claims.tag == 'bmzxzj').length > 0) {
                    this.addOrSet("jx1", "请前往预算绩效-附件管理中删除项目资金的绩效目标表");
                } else {
                    this.remove("jx1")
                }
            }
        }
    };
</script>
<style scoped>
    .upload {
        color: #9ECADF;
        font-weight: 600;
    }
</style>